<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title29"></a>
<div class="p-c"><span><em class="i">For Teresita, with all of my love.</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429976282_ded01.vue?28e70882